module.exports = __webpack_public_path__ + "img/48.71e02846.jpg";